import { TextField } from "@mui/material";
import React from "react";
import { useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function FormTextArea({
  name,
  maxLength = 5000,
  minRows = 3,
  maxRows = 4,
  placeholder,
  require,
  maxHeight = "150px",
  testId,
  ...rest
}) {
  const { register, formState } = useFormContext();
  const { errors } = formState;
  const { t } = useTranslation();

  return (
    <TextField
      multiline
      minRows={minRows}
      maxRows={maxRows}
      label={`${t(placeholder)}`}
      {...register(name, { required: require })}
      style={{
        maxWidth: "100%",
        display: "inline-flex",
      }}
      inputProps={{ maxLength: maxLength, ...(testId && { "data-testid": testId }) }}
      error={!!errors?.[name]}
      helperText={errors?.[name] ? errors?.[name].message : ""}
      {...rest}
    />
  );
}
